const new2 = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="7.33 4.5 4.67 9.17 7 9.17 5.67 12.5 11.33 7.17 8.47 7.17 10.67 4.5"/></svg>',
};

export { new2 as default };
